import $ from "jquery";

// import "../../cookie_consent/consent.js";

import "owl.carousel/dist/owl.carousel";
import "jquery-match-height";
import "imagesloaded";

import "./werkraum/jquery.focuspoint";
import "./werkraum/infiniteScroll";
import "./werkraum/chosen.jquery";
import "./werkraum/banner";
import "./werkraum/technology_video";

import initChosenSelect from "./werkraum/chosen";
import {initAjaxSolr, initAjaxSolrGroups} from "./werkraum/ajaxScrollSolr";
import "./Solr/search_controller";
import "./Solr/suggest_controller";
import "./werkraum/language_menu_fix";

$.fn.matchHeight._maintainScroll = true;

$(document).ready(function () {

  document.getElementById("mmenu-open")?.addEventListener('click', function () {
    import("./werkraum/mmenu").then((m) => m.default());
  }, {once: true});

  const megamenu = document.querySelector('.megamenu');
  if (megamenu) {
    import("./werkraum/megamenu").then((m) => new m.default(megamenu));
  }

  /**
   * ref: https://typo3.org/extensions/repository/view/focuspoint (TYPO3 Ext.)
   * ref: https://github.com/jonom/jquery-focuspoint
   */
  if (document.querySelectorAll('.focuspoint')) {
    $('.focuspoint').focusPoint();
  }

  /**
   * ref: https://owlcarousel2.github.io/OwlCarousel2/docs/api-options.html
   */
  $('.owl-carousel').owlCarousel({
    items: 1,
    loop: true,
    center: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 10000,
    autoplayHoverPause: true,
    autoplaySpeed: 1000,
    responsive: false,
    nav: false,
    onInitialized: function(event) {
      // Add aria-labels to navigation dots
      $('.owl-dot').each(function(index) {
        $(this).attr('aria-label', 'Navigate to Slide ' + (index + 1));
      });

      // Add aria-labels to navigation buttons
      $('.owl-prev').attr('aria-label', 'Previous Slide');
      $('.owl-next').attr('aria-label', 'Next Slide');
    }
  });
  /**
   * NAME: Bootstrap 3 Triple Nested Sub-Menus
   * This script will active Triple level multi drop-down menus in Bootstrap 3.*
   */
  $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
    // Avoid following the href location when clicking
    event.preventDefault();
    // Avoid having the menu to close when clicking
    event.stopPropagation();
    // Re-add .open to parent sub-menu item
    $(this).parent().toggleClass('open');
    $(this).parent().find("ul").parent().find("li.dropdown").toggleClass('open');
  });

  $('.scroll-top').click(function (event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: ($('body').offset().top) + 'px'
    }, 'fast');
  });

  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 300) {
      $('.scroll-top').addClass('scroll-top-visible');
    } else {
      $('.scroll-top').removeClass('scroll-top-visible');
    }
  });

  initChosenSelect();
  initAjaxSolr();
  initAjaxSolrGroups();
  initEqualHeights();
  initTooltips();

  // save collapse state in current session to open it again on re-visit, e.g. on form submit
  var $collapse = $('.collapse');
  $collapse.on('show.bs.collapse', function (event) {
    window.sessionStorage.setItem(`${event.target.id}_collapse`, 'active');
  });
  $collapse.on('hide.bs.collapse', function (event) {
    window.sessionStorage.removeItem(`${event.target.id}_collapse`);
  });

  $collapse.each(function () {
    var state = window.sessionStorage.getItem(`${this.id}_collapse`);
    if (state == "active") {
      $(this).collapse('show');
    }
  });

  var $tabs = $('a[data-toggle="tab"]');
  $tabs.on('show.bs.tab', function (event) {
    var $parent = $(event.target).closest('[role=tablist]');
    var href = $(event.target).attr('href');
    window.sessionStorage.setItem(`${$parent.attr('id')}_tab`, href.split('#')[1]);
  });

  $tabs.on('hide.bs.tab', function (event) {
    var $parent = $(event.target).closest('[role=tablist]');
    window.sessionStorage.removeItem(`${$parent.attr('id')}_tab`);
  });

  $('[role=tablist]').each(function() {
    var state = window.sessionStorage.getItem(`${this.id}_tab`);
    if (state && !window.location.hash) {
      $(`a[href*="#${state}"][role=tab]`).tab('show');
    }
  });

  /** ensure we force open tab if url contains hash **/
  initTabUrl();
  elementScrollIntoView();
});

$("body").on("tx_solr_updated", function () {
  initChosenSelect();
  initAjaxSolr();
  initAjaxSolrGroups();
  initEqualHeights();
  initTooltips();
  $('.focuspoint').focusPoint();
});

var loadedTimeout;
$(window).on('loaded.bk2k.responsiveimage', function () {
  clearTimeout(loadedTimeout);
  loadedTimeout = setTimeout(
    function () {
      // ref: https://github.com/liabru/jquery-match-height
      $.fn.matchHeight._update();
    },
    800
  );
});

function initEqualHeights() {
  $('[data-match-height="item"]').matchHeight({byRow: true});
  $('[data-match-height="container"]').matchHeight();
  $('[data-match-height="container-list"]').matchHeight({byRow: false});
  $('.frame-layout-4-wrapper').matchHeight();
  $('.row.zebra-row > [class*="col-"], .row.border-row > [class*="col-"]').matchHeight();
}

function initTooltips() {
  $('[data-toggle="tooltip"]').tooltip();
}

var expandAllCollapseVar = false;

function expandAllCollapse(ref, parent) {
  if (expandAllCollapseVar) {
    $(parent).find('.collapse.show').collapse('hide');
    expandAllCollapseVar = false;
    $(ref).html('Expand all');
  } else {
    $(parent).find('.collapse').collapse('show');
    expandAllCollapseVar = true;
    $(ref).html('Collapse all');
  }
}

window.expandAllCollapse = expandAllCollapse;

function initTabUrl() {
  if ($('.nav-tabs').length < 1) return;
  openTabHash();
}

function openTabHash() {
  const $navTabs = $('.nav-tabs');

  if ($navTabs.length < 1) return;

  const locationHash = window.location.hash;
  if (locationHash !== '' && $navTabs.find(`a[href="${locationHash}"]`).length > 0) {
    // if there is a match, we have to consider that there might be multiple tab container, so we open the others first !
    $navTabs.find('li:first-child a')
      .not($(`.nav-tabs a[href="${locationHash}"]`)
        .parents('ul.tabs')
        .children('a[data-toggle="tab"]'))
      .tab('show');

    $navTabs.find(`a[href="${locationHash}"]`).tab('show');
  } else {
    const path = window.location.pathname;
    $navTabs.find(`a[href="${path}"]`).tab('show');
  }

  if ($navTabs.find('li a.active').length === 0) {
    $navTabs.find('li:first-child a').tab('show');
  }

  $('.nav-tabs a').on('click',function (e) {

    if (e.target.classList.contains('pointer')) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = $(this).attr('href');
      return;
    }

    // $(this).tab('show');
    var scrollmem = $('body').scrollTop();
    if (scrollmem == 0) // gecko: body = 0, fallback to html
      scrollmem = $('html').scrollTop();
    // set
    window.location.hash = this.hash;
    $('html,body').scrollTop(scrollmem);
  });
}

function elementScrollIntoView() {
  let locationHash = window.location.hash;
  if (locationHash.length > 0) {
    const element = document.querySelector(locationHash);
    if (element) {
      const openParentElement = (child) => {
        if (child) {
          const tabPanel = child.parentElement.closest('.tab-pane');
          const collapse = child.parentElement.closest('.collapse');
          if (tabPanel instanceof HTMLElement && collapse instanceof HTMLElement) {
            if (tabPanel.contains(collapse)) {
              $(collapse).collapse('show');
              openParentElement(collapse);
            } else {
              $(`a[href*="#${tabPanel.id}"]`).tab('show');
              openParentElement(tabPanel);
            }
          } else if (collapse instanceof HTMLElement) {
            $(collapse).collapse('show');
            openParentElement(collapse);
          } else if (tabPanel instanceof HTMLElement) {
            $(`a[href*="#${tabPanel.id}"]`).tab('show');
            openParentElement(tabPanel);
          }
        }
      }
      openParentElement(element);
      setTimeout(() => {
        element.scrollIntoView();
      }, 500);
    }
  }
}

$('.embed-responsive iframe').on('load', function () {
  $.fn.matchHeight._update();
});

$('video').on('loadeddata', function () {
  $.fn.matchHeight._update();
});
